import NextImage from 'next/image'
import styles from './styles.module.scss'
import { DEFAULT_LINE_ITEM_IMAGE } from '@consts/index'

const imageLoader = ({ src }: { src: string }) => {
  return `${src}&q=75`
}
export default function OrderItemImage({ image }: { image?: string }) {
  return (
    <div className={styles.OrderItemImage}>
      {image ? (
        <NextImage
          src={image}
          alt="order image"
          width={90}
          height={136}
          loader={imageLoader}
        />
      ) : (
        <img
          src={DEFAULT_LINE_ITEM_IMAGE}
          alt="order thumbnail"
          width={90}
          height={136}
        />
      )}
    </div>
  )
}
